import Leasing from './Leasing';
import { NAME } from './constants';

export default {
  NAME,
  Leasing,
};
